exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lucky-wheel-customer-tooltip{max-width:480px;-webkit-box-sizing:border-box;box-sizing:border-box;word-break:break-word;white-space:normal;line-height:1.5}", ""]);

// exports
